<template>
  <div style="height: 100%; background:linear-gradient(to bottom,rgb(5, 20, 90), rgb(6, 27, 114), rgb(3, 50, 165))">
    <div class="contentbox">
      <div class="content">
        <div class="logo">
          <img :src="`${IP_TEST}/uploads/${logopic}`" alt="" @click="$router.push('/')">
        </div>
    
        <div class="inqBox">
          
            <div class="allbox">
              <div class="leftBox">
                <div class="inqtype" >
                  <ul>
                    <li @click="inqType='gr'">
                      <a href="javascript:;;" :class="inqType=='gr'?'active':''">
                        个人会员
                      </a>
                      
                    </li>
                    <li @click="inqType='dw'">
                      <a href="javascript:;;" :class="inqType==='dw'?'active':''" >
                        单位会员
                      </a>
                    </li>
                    <li @click="inqType='ban'">
                      <a href="javascript:;;" :class="inqType==='ban'?'active':''" >
                        备案查询
                      </a>
                    </li>
                  </ul>
                </div>
                <div v-if="inqType=='gr'">
                  <input type="text" v-model="cert.name" class="inname" placeholder="姓       名"/>
                  <input type="text" v-model="cert.code" class="incert" placeholder="会员证号"/>
                </div>
                <div v-else-if="inqType=='ban'">
                  <input type="text" v-model="cert.companyname" class="inname" placeholder="企业名称"/>
                  <input type="text" v-model="cert.code" class="incert" placeholder="备案登记号"/>
                </div>
                <div v-else>
                  <input type="text" v-model="cert.companyname" class="inname" placeholder="企业名称"/>
                  <input type="text" v-model="cert.code" class="incert" placeholder="会员证号"/>
                </div>
                <button @click="submitForm() ">查询</button>
                
              </div>
             
        </div>

            </div>
            <div class="memberfile">
                  <div class="filetitle">
                    <h2>
                      <img src="/static/img/fujin.png" alt="">
                    附：会员申请表格：
                    </h2>
                  </div>
                  <div class="filelist">
                    <ul>
                      <li v-for="(file ,index) in applyFiles" :key="index">
                        <router-link v-if="!file.filesrc" :to="`/news/info/${file.plateid}/${file.uuid}`">
                          <i class="el-icon-video-play"></i>{{file.title}}
                        </router-link>
                        <a v-else :href="`${IP_TEST}/uploads/${file.filesrc}`" ><i class="el-icon-video-play"></i>{{file.title}}</a>
                      </li>
                    </ul>
                  </div>
                </div>
      </div>
      
    </div>
  </div>
    
  </template>
  
  <script>
  
  import { getPersonalMember,getCompanyMember,getBeiAn  } from '@/request/index';
  import { getCertTypes,getFindPage ,getArticles} from '@/request/get';
  import { IP_TEST } from '@/config'
  const rate = window.outerWidth / 599;
  export default {
    metaInfo: {
      title: '会员查询',
      meta: [
        {
          name: 'viewport', content:
            `width=device-width, user-scalable=yes, initial-scale=${rate}, maximum-scale=${10}, minimum-scale=${rate}`
        }
      ]
    },
    name: "inquery",
    components: {
    },
    computed:{
    logopic() {
      return this.$store.getters.logopic;
    }
  },
    data() {
      return {
        occupations: [],
        occupationFlag:false,
        cert: {
          name: "",
          code:"",
          companyname:""
        },
        applyFiles:[],
        selcertname:"",
        gourl:"",
        certTypes:[],
        inqType:'gr',
        IP_TEST
      }
    },
    created(){
     if(this.$route.query&&this.$route.query.inqtype)
      this.inqType = this.$route.query.inqtype;
     this.getCertTypes();
     this.getFindPage();
  
    },
    mounted() {
      var lastTouchEnd = 0;
      document.addEventListener(
        "touchend",
        function (event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
    },
    methods: {
      async getFindPage() {
        let result = await getFindPage();
        result = result.data || [];
        this.$store.dispatch("SET_PLATES", result)
        let { plates } = this.$store.state;
        let list = plates.filter((item) => '会员附件' == item.name);
        let uuid = list[0].uuid;
        result =  await getArticles(uuid);
        this.applyFiles = result.data ||[];
      },
      goHome() {
        this.$router.push("/");
      },
      handleInq() {
        if (!this.selcertname) {
          this.$message.error("请选择职业名称");
          return;
        }
        for(let i=0;i<this.occupations.length;i++)
        { 
          if(this.occupations[i].certname==this.selcertname)
          {
            this.cert = this.occupations[i];
            break;
          }
        }
        this.$router.push({
          name: "Show",
          query: {
            name: this.cert.name,
            code: this.cert.code,
            certtypename: this.cert.certtypename
          }
        })
      },
      async getCertTypes(){
        let result = await getCertTypes();
        this.certTypes = result.data;
      },
      /**
       *  cname: "单位名称"或姓名,
          ccode: "信用代码"或证件号,
          bzcode: "证书编号"或标准号
      */
      async submitForm() {
        if(this.inqType=='gr')
        {
          if ((this.cert.name == "" && this.cert.code == "")) {
            return;
          }
          let result =await getPersonalMember(this.cert.name,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                name: this.cert.name,
                code: this.cert.code,
                inqType:"gr"
              }
            })
          }else{
            this.$message.error("您输入的会员信息不存在，谨防假冒。");
          }
        }else if(this.inqType=='dw'){
          if ((this.cert.companyname == "" && this.cert.code == "")) {
            return;
          }
          let result =await getCompanyMember(this.cert.companyname,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                companyname: this.cert.companyname,
                code: this.cert.code,
                inqType:"dw"
              }
            })
          }else{
            this.$message.error("您输入的会员信息不存在，谨防假冒。");
          }
        }else{
          if ((this.cert.companyname == "" && this.cert.code == "")) {
            return;
          }
          let result =await getBeiAn(this.cert.companyname,this.cert.code);
          if(result.data.length>0)
          {
            this.$router.push({
              name: "MemberRlt",
              query: {
                companyname: this.cert.companyname,
                code: this.cert.code,
                inqType:"ban"
              }
            })
          }else{
            this.$message.error("您输入的备案信息不存在，谨防假冒。");
          }
        }
       
      }
    }
  };
  </script>
  <style scoped >
  
  .logo{
      text-align: left;
      position: relative;
      top:58px;
      top: 31px;
    width: 92vw;
  }
  .contentbox{
    min-height: 100%;
     
      background-image:url(/static/img/beijign.png);
      background-size: cover;
      background-repeat: no-repeat;
      padding-bottom: 50px;
  }
  .contentbox .content{
    width: 94vw;
    margin:auto;
  }
  .inqBox{
      position: relative;
      top: 92px;
      width: 94vw;
      height: 553px;
      background:rgba(148,178,247,0.4);
      /* background-image: url(/static/img/info_bg.png); */
      border-radius: 16px 16px 16px 16px;
      opacity: 1;
      margin: auto;
      /* padding: 29px; */
      text-align: center;
      /* backdrop-filter: blur(1px); */
  }
  .inqBox h1{
      font-size: 32px;
      
      font-weight: bold;
      color: #FFFFFF;
      line-height: 23px;
      text-align: center;
  }
  .leftBox input {
      width: 81vw;
      height: 88px;
      background:rgba(13, 0, 94, 0.6);
      margin-top:47px ;
      border-radius: 5px;
      font-size: 18px;
      padding: 0px 0px 0px 5vw;
      color: #FFFFFF;
  }
  .leftBox button {
    width: 87vw;
    height: 75px;
    margin-top: 47px;
    background:  linear-gradient(22deg, rgba(41,130,242,0.82), rgba(0,63,210,0.82));
    border-radius: 8px 8px 8px 8px;
    font-size: 24px;
    
    font-weight: bold;
    color: #FFFFFF;
    line-height: 28px;
  }
  .allbox{
    /* margin-top:10px; */
    height: 369px;
    display: flex;
    position: relative;
    top: 56px;
  }
  .leftBox{
    width:95vw;
    /* height: */
    height: 369px;
  }
  .intype >>>.el-input__inner{
    background-color:transparent;
    border:none;
    height: 46px;
      line-height: 46px;
      padding:0px;
      font-size: 16px;
      color: #FFFFFF;
  }
  .kouniu2{
    position: relative;
      top: -67px;
      left: 57px;
      width: 52px;
  }
  .inqtype ul li{
    display: inline-block;
    width: 30vw;
    text-align: center;
  }
  .inqtype ul li a{
    color: rgba(255,255,255,0.6);
    font-size: 28px;
    line-height: 53px;
    letter-spacing: 7px;
    
  }
  .inqtype ul li .active::after{
    content: "";
    height: 6px;
    border-radius: 3px;
    display: block;
    background-color: #fff;
    width: 142px;
    margin: auto;
  }
  .memberfile{
    margin-top:114px;
    /* display: flex; */
    padding-top:15px;
    padding-left: 25px;
    min-height: 290px;
    background: rgba(26, 25, 128, 0.1);
    border: 2px solid rgba(68, 151, 243, 0.5);
    border-radius: 18px;
    padding-bottom:15px;
  }
  .memberfile img{
    position: relative;
    top: 5px;
  }
  .memberfile .filetitle{
    /* width: 153px; */
    /* display: inline-block; */
  }
  .memberfile .filetitle h2 {
    font-size:24px;
    color: rgba(255,255,255,0.6);
    text-align: left;
    line-height: 55px;
  }
  .memberfile .filelist{
    /* width:463px; */
    /* display: inline-block; */
    text-align: left;
    line-height: 45px;
  }
  .memberfile .filelist a{
    color: #fff;
    /* line-height:52x; */
    font-size: 23px;
    border-bottom: solid 1px;
  }
  .rightBox img{
    position: relative;
    top: 88px;
    left: 23px;
  }
  </style>
  